module.exports = __webpack_public_path__ + "img/default_avator.47ef729f.png";